import { render, staticRenderFns } from "./serviceTypeList.vue?vue&type=template&id=7c546fa6&scoped=true"
import script from "./serviceTypeList.vue?vue&type=script&lang=js"
export * from "./serviceTypeList.vue?vue&type=script&lang=js"
import style0 from "./serviceTypeList.vue?vue&type=style&index=0&id=7c546fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c546fa6",
  null
  
)

export default component.exports